import React from "react";
import classNames from "classnames";
import mixpanel from "mixpanel-browser";

import { createKeyboardShortcut } from "utils/keyboardShortcuts";
import VideoTutorialLink from "components/VideoTutorialLink";
import { getTutorialVideoUrl } from "features/Resources/tutorialVideos";

import classes from "./style.module.scss";

import Info from "assets/images/icons/JSX/info";

const HeaderLinks = ({ videoKey, headerLinksClassName }) => (
    <div className={classNames(classes.headerLinks, headerLinksClassName)}>
        {videoKey && <VideoTutorialLink videoKey={videoKey} />}
    </div>
);

const TabVideoTutorialButton = ({ videoKey, title }) => (
    <a
        href={getTutorialVideoUrl(videoKey)}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.detailsInfoButton}
        aria-label={`${title} video tutorial`}
    >
        <Info width="16px" height="16px" />
    </a>
);

const TabDetailsButton = ({ detailsTrigger, detailsText, title }) => {
    const openDetails = () => {
        detailsTrigger();
        mixpanel.track("Details Drawer Open", {
            "Drawer Name": detailsText || `${title} details`,
        });
    };

    return (
        <button
            type="button"
            className={classes.detailsInfoButton}
            onClick={openDetails}
            aria-label={detailsText || `Open ${title} details`}
            {...createKeyboardShortcut({ onKeyDown: openDetails })}
        >
            <Info width="16px" height="16px" />
        </button>
    );
};

export default ({
    title = "",
    description = "",
    children,
    detailsTrigger,
    detailsText,
    detailsVideoKey,
    videoKey,
    style,
    additionalContent,
    headingEndContent,
    className,
    noBorder,
    additionalContentClassName,
    titleRowClassName,
    headerLinksClassName,
    inlineHeaderLinks = false,
}) => {
    const headerLinks = videoKey ? (
        <HeaderLinks videoKey={videoKey} headerLinksClassName={headerLinksClassName} />
    ) : null;

    return (
        <div
            className={classNames(classes.tabHeader, noBorder && classes.noBorder, { [className]: className })}
            style={style}
        >
            <div className={classNames(classes.titleRow, titleRowClassName)}>
                <div className={classes.heading}>
                    {title && (
                        <div className={classes.titleWithIcon}>
                            <h3>{title}</h3>
                            {detailsVideoKey ? (
                                <TabVideoTutorialButton videoKey={detailsVideoKey} title={title} />
                            ) : (
                                detailsTrigger && (
                                    <TabDetailsButton
                                        detailsTrigger={detailsTrigger}
                                        detailsText={detailsText}
                                        title={title}
                                    />
                                )
                            )}
                        </div>
                    )}
                    {description && <p>{description}</p>}
                </div>
                {headingEndContent && <div className={classes.headingEnd}>{headingEndContent}</div>}
            </div>
            {additionalContent && (
                <div
                    className={classNames(classes.additionalContent, additionalContentClassName, {
                        [classes.additionalContentWithLinks]: inlineHeaderLinks,
                    })}
                >
                    {additionalContent}
                    {inlineHeaderLinks && headerLinks}
                </div>
            )}
            {!inlineHeaderLinks && headerLinks}
        </div>
    );
};
